import {
  AlinPatron,
  ByronKeithAdams,
  ChadRicher,
  CharlesBurkeCowley,
  CharlesHouser,
  DenisMezer,
  GregMaes,
  IanDickey,
  IgorPapo,
  IvanGalkin,
  JonWilburn,
  JosephDiMelis,
  JoshuaStewart,
  KevinBrophy,
  KyleClausen,
  LoganBerlin,
  MattLutton,
  MihaelaPoiata,
  PhilipBayne,
  QuranOsiris,
  RimaNemtu,
  SergeyBogutsky,
  SergheiBusmachi,
} from '../../images/about-us/redesign';

const employees = [
  {
    title: 'Leadership',
    infoList: [
      {
        image: SergheiBusmachi,
        title: 'Serghei Busmachiu',
        text: 'Chief Executive Officer',
        popupContent: {
          name: 'Serghei Busmachiu',
          position: 'Chief Executive Officer',
          description:
            'Serghei Busmachiu, with a strategic vision and leadership expertise, has founded and currently leads four successful companies: Utilities One, Moldcable, Energy5, and US Software Solutions. He executes profound industry insights to drive sustainable company growth and ensures effective management of high-performing teams.',
        },
      },
      {
        image: JosephDiMelis,
        title: 'Joseph DiMelis',
        text: 'Executive Vice President and COO',
        popupContent: {
          name: 'Joseph DiMelis',
          position: 'Executive Vice President and COO',
          description:
            "Joseph DiMelis's career spans over thirty years in the Telecom industry and has significantly impacted major enterprises, including AT&T, Time Warner Cable Inc., Charter Communications, and Ziply Fiber. His expertise in strategic planning, cost management, and team development has consistently delivered breakthrough performance and operational improvements.",
        },
      },
      {
        image: AlinPatron,
        title: 'Alin Patron',
        text: 'Chief Strategy Officer',
        popupContent: {
          name: 'Alin Patron',
          position: 'Chief Strategy Officer',
          description:
            'Alin Patron, leveraging a profound background in Business Administration and Management, serves as a driving force behind development at Utilities One. Acknowledged for his meticulous attention to detail and outstanding problem-solving abilities, Alin has previously held the prominent role of Business Development Executive.',
        },
      },
      {
        image: IvanGalkin,
        title: 'Ivan Galkin',
        text: 'Vice President Fulfillment & Installation',
        popupContent: {
          name: 'Ivan Galkin',
          position: 'Vice President Fulfillment & Installation',
          description:
            "Ivan Galkin's expertise evolved from Lead Sales Manager to Senior Manager promotion within Lexus Inc. company, then Anti-Crisis management at Porsche Inc., and now as a remarkable Vice President at Utilities One, where he grew from operations technician up to VP, proofing exceptional ability in addressing challenges and adeptly resolving complex situations.",
        },
      },
      {
        image: IanDickey,
        title: 'Ian Dickey',
        text: 'Vice President - Construction East',
        popupContent: {
          name: 'Ian Dickey',
          position: 'Vice President - Construction East',
          description:
            'Ian Dickey brings over 29 years of experience in the telecommunications industry, with a proven track record in leading fulfillment, maintenance, and construction operations. He played a key role in driving performance improvements, financial results, and cultural transformation at Time Warner Cable and Charter Communications. Ian Dickey now serves as VP/GM of Utilities One Group, where he continues to apply his operational expertise to deliver excellence and growth.',
        },
      },
      {
        image: LoganBerlin,
        title: 'Logan Berlin',
        text: 'Vice President - Construction West',
        popupContent: {
          name: 'Logan Berlin',
          position: 'Vice President - Construction West',
          description:
            'Logan brings over a decade of experience in telecom, starting as a technician and advancing through key roles in fiber optic construction. He has managed commercial, MDU, and SFU builds, overseeing all aspects from engineering to permitting and construction—with a strong focus on field execution. At Tillman Fiber, he led the launch and rapid expansion of network builds across 11 markets.',
        },
      },
      {
        image: MihaelaPoiata,
        title: 'Mihaela Poiata',
        text: 'Chief Accounting Officer',
        popupContent: {
          name: 'Mihaela Poiata',
          position: 'Chief Accounting Officer',
          description: '',
        },
      },
      {
        image: ChadRicher,
        title: 'Chad Richer',
        text: 'Senior Vice President - Business Development',
        popupContent: {
          name: 'Chad Richer',
          position: 'Senior Vice President - Business Development',
          description:
            'As Senior Vice President of Business Development at Utilities One Group, Chad Richer leads strategic initiatives to expand market presence and drive sustained revenue growth. With over 20 years of experience in sales leadership across the telecom and infrastructure sectors, including roles at PrecisionOT, PCT International, and PPC Broadband, Chad has built a strong track record in scaling high-performing teams, developing long-term client partnerships, and executing data-driven sales strategies that deliver measurable results.',
        },
      },
      {
        image: ByronKeithAdams,
        title: 'Byron Keith Adams',
        text: 'Vice President - Power Delivery Services',
        popupContent: {
          name: 'Byron Keith Adams',
          position: 'Vice President - Power Delivery Services',
          description:
            'Kenny Adams is an electric utility executive with over 30 years of experience in T&D construction and maintenance. He has held leadership roles at Duke Energy and PG&E, with expertise in operational excellence, risk management, safety, capital project management, outage coordination, compliance, and the integration of advanced technologies. As Vice President of Power Delivery Services at Utilities One Group, he leads infrastructure strategy, business development, and cross-functional teams to drive growth and efficiency.',
        },
      },
      {
        image: GregMaes,
        title: 'Greg Maes',
        text: 'Vice President - Engineering',
        popupContent: {
          name: 'Greg Maes',
          position: 'Vice President - Engineering',
          description:
            'Greg Maes is a telecom engineering executive with over 20 years of experience in fiber network construction, planning, and infrastructure management. He has held senior leadership roles at Pike Telecom and United Communications, where he specialized in network design, ROW permitting, and business process improvement. A graduate of the University of Florida, Greg combines a strong technical foundation with real-world execution, bringing both strategic insight and hands-on expertise to every project. As Vice President of Engineering at Utilities One Group, he leads planning, cross-functional coordination, and operational delivery for telecom infrastructure nationwide.',
        },
      },
    ],
  },
  {
    title: 'Board of Directors',
    infoList: [
      {
        image: DenisMezer,
        title: 'Denis Mezer',
        text: 'Senior Director - Construction Field Services & Splicing',
        project: 'OSP Construction',
      },
      {
        image: CharlesHouser,
        title: 'Charles Houser',
        text: 'Senior Director - OSP Construction',
      },
      {
        image: MattLutton,
        title: 'Matt Lutton',
        text: 'Senior Director - OSP Construction',
      },
      {
        image: JoshuaStewart,
        title: 'Joshua Stewart',
        text: 'Senior Director - OSP Construction',
      },
      // {
      //   image: AnthonyRich,
      //   title: 'Anthony Rich',
      //   text: 'Director - OSP Construction',
      // },
      {
        image: IgorPapo,
        title: 'Igor Papo',
        text: 'Director - OSP Construction',
      },
      {
        image: QuranOsiris,
        title: 'Qur’an Osiris',
        text: 'Director - OSP Construction',
      },
    ],
  },
  {
    infoList: [
      {
        image: JonWilburn,
        title: 'Jon Wilburn',
        text: 'Director - Engineering',
        project: 'OSP Engineering',
      },
      {
        image: KevinBrophy,
        title: 'Kevin Brophy',
        text: 'Director - Water Utilities',
        project: 'Water',
      },
      {
        image: KyleClausen,
        title: 'Kyle Clausen',
        text: 'Director - Wireless Development',
        project: 'Wireless',
      },
      {
        image: RimaNemtu,
        title: 'Rima Nemtu',
        text: 'Director - Consulting Services Operations',
        project: 'Consulting',
      },
      // {
      //   image: SergiuRobu,
      //   title: 'Sergiu Robu',
      //   text: 'Director of IT Team',
      //   project: 'It',
      // },
      {
        image: PhilipBayne,
        title: 'Philip Bayne',
        text: 'National Director – Support Services',
        project: 'Pmo',
      },
      {
        image: CharlesBurkeCowley,
        title: 'Charles Burke Cowley',
        text: 'Director - Construction Support Services',
      },
      {
        image: SergeyBogutsky,
        title: 'Sergey Bogutsky',
        text: 'Talent Acquisition Director',
        project: 'Hr',
      },
    ],
  },
];

export default employees;
